export type RumKnownApps = 'account' | 'route' | 'order'

export type RumMiddlewareOutput = {
  bundleSrc?: string
  config: {
    rumCounter: Pick<Ya.Rum.RUMSettings, 'clck' | 'reqid'> & Ya.Rum.RumVars
    errorCounter: Ya.Rum.LogErrorInitSettings
  }
  inlineJs: {
    rumCounter: string
    mfpObserver?: string
  }
}

export enum RumTimeMark {
  BEFORE_JS_FRAMEWORK_INIT = '3070',
  JS_FRAMEWORK_INITED = '3036',
  REACT_INITED = 'react.inited',
}
